import { Injectable, inject } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";

import { TranslateService, TranslationPath } from "#modules/shared/i18n";

@Injectable({ providedIn: "root" })
export class ToastService {
  private readonly snackService = inject(MatSnackBar);
  private readonly translateService = inject(TranslateService);

  private getTranslation(langToken: TranslationPath) {
    return this.translateService.instant(langToken) ?? langToken;
  }

  warning(langToken: TranslationPath, duration = 3000) {
    this.snackService.open(this.getTranslation(langToken), undefined, {
      panelClass: "toast-warning",
      duration,
    });
  }

  error(langToken: TranslationPath | string, duration = -1) {
    const closeAction = "╳";
    this.snackService.open(this.getTranslation(langToken as TranslationPath), closeAction, {
      panelClass: "toast-error",
      duration,
    });
  }

  success(langToken: TranslationPath, duration = 3000) {
    this.snackService.open(this.getTranslation(langToken), undefined, {
      panelClass: "toast-success",
      duration,
    });
  }

  info(langToken: TranslationPath, duration = 3000) {
    this.snackService.open(this.getTranslation(langToken), undefined, {
      panelClass: "toast-info",
      duration,
    });
  }
}
